import { BehaviorSubject } from "rxjs";
import { useState, useEffect } from "react";

/**
 * React hook that allows a component to hook into an observable Behavior Subject.
 *
 * @template T
 * @param {BehaviorSubject<T>} subject
 * @returns {[T, (nextValue: T) => void]}
 */
function useBehaviorSubject<T>(subject: BehaviorSubject<T>): T {
  const [value, setValue] = useState<T>(subject.value);

  useEffect(() => {
    const subscription = subject.subscribe((nextValue) => {
      setValue(nextValue);
    });

    return () => subscription.unsubscribe();
  }, [subject]);

  return value;
}

export default useBehaviorSubject;
